import styles from "../chat-bubble.module.css";

function SkeletonBubble({ isMine }: { isMine: boolean }) {
  return (
    <div className={`${styles.row} ${isMine ? styles.mine : styles.theirs}`}>
      <div className={`${styles.bubbleWrapper} ${styles.skeletonWrapper}`}>
        <div className={styles.infoAndTextWrapper}>
          <span className={styles.userInfo}>
            <span
              className={`${styles.skeletonBlock} ${styles.skeletonName}`}
            />
            <div className={styles.skeletonAvatar} />
          </span>
          <div
            className={`${styles.skeletonBlock} ${styles.skeletonText}`}
            style={{ width: "85%" }}
          />
          <div
            className={`${styles.skeletonBlock} ${styles.skeletonText}`}
            style={{ width: "60%" }}
          />
        </div>
      </div>
    </div>
  );
}

export default function ChatLoadingSkeleton() {
  return (
    <div className={styles.skeletonContainer}>
      {/* Renders a fake conversation while loading */}
      <SkeletonBubble isMine={false} />
      <SkeletonBubble isMine={true} />
      <SkeletonBubble isMine={false} />
      <SkeletonBubble isMine={false} />
      <SkeletonBubble isMine={true} />
    </div>
  );
}
